import React, { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { CopyText } from '../../../UiKit';
import { useQueryCall } from '../../../api/react-client';
import { lifelineEndPoints } from '../../../api/end-points';
import { Eye } from 'lucide-react';

export const OrderOtp = ({ orderId }) => {
  const [Otp, setOtp] = useState(null);
  const [isMask, setIsMask] = useState(true);
  const queryKeys = ['lifeline_apis', 'get_delivery_otp', orderId];
  const getOrderOtp = `${lifelineEndPoints.GET_ORDER_OTP}?order_id=${orderId}`;
  const { refetch: fetchOtp } = useQueryCall(
    {
      enabled: false,
      onSettled: (response) => {
        if (!response || response?.isError)
          return toast.error(
            response?.message ||
              'Something went wrong. Please try again later!',
          );
        setIsMask(false);
        setOtp(response?.delivery_otp);
      },
      onError: (err) => {
        console.log('err', err);
      },
    },
    getOrderOtp,
    queryKeys,
  );

  const unmaskOtp = useCallback(
    (orderId) => {
      fetchOtp(orderId);
    },
    [fetchOtp],
  );

  return (
    <div className='tw-flex tw-flex-row tw-h-fit tw-items-center'>
      <div className='tw-flex tw-items-center'>
        <div className='tw-text-[1.2rem] tw-font-medium tw-px-[8px] tw-py-[4px] tw-rounded-lg tw-bg-grey-200 tw-mr-2'>
          OTP
        </div>
        {isMask ? (
          <div className='tw-text-zinc-600 tw-font-regular'>••••</div>
        ) : (
          <div
            className='tw-text-zinc-600 tw-font-regular'
            data-dd-privacy='mask'
          >
            <CopyText title={Otp} />
          </div>
        )}
      </div>
      <div className='tw-ml-2'>
        {isMask && (
          <Eye
            size={16}
            strokeWidth={1.5}
            className='tw-cursor-pointer tw-text-grey-400 hover:tw-text-grey-500 tw-transition-colors tw-ease-in-out tw-duration-200'
            onClick={() => unmaskOtp(orderId)}
          />
        )}
      </div>
    </div>
  );
};
